<div class="search-input-container d-flex align-items-center p-3 flex-shrink-0 border-bottom">
    <fa-icon [icon]="faSearch" class="search-icon text-secondary me-2" aria-hidden="true" />

    <!-- Active Filters -->
    @if (hasActiveFilters()) {
        @if (courseFilterLabel()) {
            <span class="filter-chip course-filter-chip me-2" [attr.aria-label]="'global.search.filterChipAriaLabel' | artemisTranslate: { filter: courseFilterLabel()! }">
                <span class="filter-chip-label">{{ courseFilterLabel() }}</span>
                <button type="button" class="filter-chip-remove" (click)="onCourseFilterRemove()" aria-label="Remove" tabindex="-1">
                    <fa-icon [icon]="faTimes" />
                </button>
            </span>
        }
        @for (filter of displayFilters(); track filter) {
            <span class="filter-chip search-filter-chip me-2" [attr.aria-label]="'global.search.filterChipAriaLabel' | artemisTranslate: { filter: getFilterLabel(filter) }">
                <span class="filter-chip-label">{{ getFilterLabel(filter) }}</span>
                <button type="button" class="filter-chip-remove" (click)="onFilterRemove(filter)" aria-label="Remove" tabindex="-1">
                    <fa-icon [icon]="faTimes" />
                </button>
            </span>
        }
    }

    <input
        #searchInput
        type="text"
        [value]="searchQuery()"
        (input)="onInput($event)"
        (keydown)="onKeyDown($event)"
        [placeholder]="'global.search.placeholder' | artemisTranslate"
        class="search-input flex-grow-1 border-0 bg-transparent text-body"
        style="outline: none"
        [attr.aria-label]="'global.search.placeholder' | artemisTranslate"
        autocomplete="off"
    />

    @if (isLoading()) {
        <span class="spinner-border spinner-border-sm text-secondary" role="status" [attr.aria-label]="'global.search.searching' | artemisTranslate"></span>
    }
</div>
